module.exports = __webpack_public_path__ + "img/yes-match-t.a0b7f9da.png";